module.exports = __webpack_public_path__ + "media/images/icons/edit_musical-7f70e624b3b116012232f3adb291f0a5.svg";